<template>
  <div class="fixed top-0 left-0 w-screen h-full bg-white">
    <page class="h-full">
      <template #rightBtn>
        <img
          src="../../../assets/common/close-icon.svg"
          alt="menu"
          @click="$emit('clear-active-page')"
        />
      </template>
      <template #content>
        <div class="title text-xl">{{ $t('login.login_title') }}</div>
        <div class="mb-5 text-xl">{{ $t('login.login_phone_title') }}</div>
        <div class="input-wrapper flex mb-5" :class="{ focus: inputFocus === 'account' }">
          <div class="w-20 bg-transparent inline-flex items-center" @click="openCountryCode">
            <span class="inline-block ml-4">
              {{ countryCode.value }}
            </span>
            <img class="ml-2" src="../../../assets/common/chevron-down.svg" />
          </div>
          <input
            class="flex-1 h-12 px-6"
            type="text"
            autofocus
            v-model.trim="localNumber"
            :placeholder="$t('login.enter_phone_number')"
            inputmode="numeric"
            @click="inputFocus = 'account'"
          />
        </div>
        <div class="input-wrapper relative" :class="{ focus: inputFocus === 'password' }">
          <input
            class="w-full h-12 pl-6"
            :type="inputType"
            v-model="password"
            :placeholder="$t('login.password')"
            @click="inputFocus = 'password'"
            @keyup.enter="login"
          />
          <img
            v-if="isHide"
            class="eye-icon absolute"
            src="../../../assets/common/eye.svg"
            @click="isHide = !isHide"
          />
          <img
            v-else
            class="eye-icon absolute"
            src="../../../assets/common/black-eye.svg"
            @click="isHide = !isHide"
          />
        </div>
        <div class="forget-text mt-1 text-xs text-right underline" @click="isShow = true">
          {{ $t('login.forget_password') }}
        </div>
        <c-button :confirmed-status="confirmedStatus" class="relative mt-12" @click="login">
          <span>{{ $t('login.login') }}</span>
        </c-button>
        <error-message v-if="errorMsg" :message="errorMsg" />
      </template>
    </page>
    <forget-pwd
      v-if="isShow"
      :type="'phone'"
      :is-show.sync="isShow"
      :country-code.sync="countryCode"
      @edit-code="openCountryCode"
      @clear-active-page="$emit('clear-active-page')"
    />
    <country-code
      v-if="showCountryCode"
      :country-code.sync="countryCode"
      @set-close-status="closeCountryCode"
      @use-email="$emit('use-email')"
    />
  </div>
</template>

<script>
import ApiActions from '@/modules/api-actions';
import handlePhoneInput from '@/mixins/handle-phone-input';
import loginError from '@/mixins/login-error';
import Page from '@/components/common/Page.vue';
import CButton from '@/components/common/CButton.vue';
import CountryCode from './SupportedCountryCode.vue';
import ForgetPwd from './ForgetPwd.vue';
import ErrorMessage from '../common/ErrorMessage.vue';

export default {
  mixins: [handlePhoneInput, loginError],
  components: {
    Page,
    CButton,
    CountryCode,
    ForgetPwd,
    ErrorMessage,
  },
  data() {
    return {
      password: '',
      isHide: true,
      isShow: false,
      inputFocus: 'account',
      errorMsg: null,
    };
  },
  computed: {
    confirmedStatus() {
      return this.password.length > 3 && this.localNumber.length > 2;
    },
    inputType() {
      return this.isHide ? 'password' : 'text';
    },
  },
  methods: {
    async login() {
      if (!this.confirmedStatus) return;

      this.$events.startLoading();
      try {
        await ApiActions.user.login({
          username: this.phoneNumber,
          password: this.password,
          provider: 0,
        });
        this.$emit('done');
      } catch (e) {
        this.errorMsg = this.handleLoginError(e);
        this.$events.stopLoading();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.title {
  color: #572bff;
}

.input-wrapper {
  @apply rounded;
  width: 309px;
  background-color: #f5f5f5;
  input {
    outline: none;
    background: none;
    width: 80%;
  }
}

.focus {
  @apply bg-no-repeat;
  @apply bg-contain;
  @apply bg-white;
  background-image: url('../../../assets/common/rectangle-1334.svg');
}

.forget-text {
  width: 309px;
}

.eye-icon {
  top: 50%;
  right: 21px;
  transform: translateY(-50%);
}
</style>
